enum TypePageActionTypes {
  ADD_TYPE_PAGE = "ADD_TYPE_PAGE",
}

export default TypePageActionTypes
